module.exports = __webpack_public_path__ + "img/cucumber.031319a5.png";